import { Components, Theme } from '@mui/material';

export default {
  defaultProps: {
    variantMapping: {
      h1Custom: 'h1',
      h6Bold: 'h6',
      subtitle1Bold: 'h6',
      subtitle2Bold: 'h6',
      body1Bold: 'p',
      body2Bold: 'p',
      overlineBold: 'span',
      captionBold: 'span',
    }
  },
} as Components<Theme>['MuiTypography'];